// DI   TGP-028
// Newsletter subscribe form spinner handling

document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.newsletter-subscribe__form');
  if (form) {
    form.addEventListener('submit', function(e) {
      const button = form.querySelector('.newsletter-subscribe__cta');
      const buttonText = button.querySelector('.newsletter-subscribe__cta-text');
      const spinner = button.querySelector('.newsletter-subscribe__spinner');
      
      if (button && buttonText && spinner) {
        button.disabled = true;
        buttonText.style.display = 'none';
        spinner.style.display = 'inline-block';
      }
    });
  }
});
